export default "__VITE_ASSET__7cdd77bd__"